import {
  AccordionRootProps,
  Box,
  chakra,
   
  Accordion as ChakraAccordion,
} from "@chakra-ui/react";
import React, { FC, ReactElement } from "react";
import {
  accordionRootRecipe,
  accordionItemRecipe,
  accordionItemTriggerRecipe,
  accordionItemBodyRecipe,
} from "./accordion.recipe";

export const AccordionRoot = chakra(ChakraAccordion.Root, accordionRootRecipe);
export const AccordionItem = chakra(ChakraAccordion.Item, accordionItemRecipe);
export const AccordionItemTrigger = chakra(
  ChakraAccordion.ItemTrigger,
  accordionItemTriggerRecipe,
);
export const AccordionItemBody = chakra(
  ChakraAccordion.ItemBody,
  accordionItemBodyRecipe,
);
export const AccordionItemIndicator = ChakraAccordion.ItemIndicator;
export const AccordionItemContent = ChakraAccordion.ItemContent;

type Props = {
  items: { id: string; title: string; content: ReactElement }[];
} & AccordionRootProps;

const Accordion: FC<Props> = ({ items, ...props }) => (
  <AccordionRoot {...props}>
    {items.map(({ id, title, content }) => (
      <React.Fragment key={id}>
        <AccordionItem value={id}>
          <AccordionItemTrigger>
            <ChakraAccordion.ItemIndicator />
            <Box as="span" flex="1" textAlign="left" fontWeight="bold">
              {title}
            </Box>
          </AccordionItemTrigger>

          <ChakraAccordion.ItemContent>
            <AccordionItemBody>{content}</AccordionItemBody>
          </ChakraAccordion.ItemContent>
        </AccordionItem>
      </React.Fragment>
    ))}
  </AccordionRoot>
);

export default Accordion;
